import { get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from '../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import { isTrue } from '../../../../../../utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const SchutzRechte: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Schutzrechte, Normen und Standards' description={PLATZHALTER_TEXT} />
			<CreateTable
				formStruc={formStrucSchutzRechte(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				columnsLabel={columnsLabel()}
			/>
		</>
	);
};
export default SchutzRechte;

const columnsLabel = () => {
	let labels = ['', 'Angabe', 'Anzahl'];
	return labels;
};
export const formStrucSchutzRechte = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					type: 'label',
					path: P.Schutzrechte_Normen_Und_0194594597_Neu_Angemeldet_Werden_Angabe.path,
				},

				{ ...P.Schutzrechte_Normen_Und_0194594597_Neu_Angemeldet_Werden_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Schutzrechte_Normen_Und_0194594597_Neu_Angemeldet_Werden_Angabe.path)) ?
					[P.Schutzrechte_Normen_Und_0194615116_Neu_Angemeldet_Werden_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Schutzrechte_Normen_Und_0221509941_Neu_Angemeldet_Werden_Angabe.path,
				},

				{ ...P.Schutzrechte_Normen_Und_0221509941_Neu_Angemeldet_Werden_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Schutzrechte_Normen_Und_0221509941_Neu_Angemeldet_Werden_Angabe.path)) ?
					[P.Schutzrechte_Normen_Und_0221456732_Neu_Angemeldet_Werden_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Schutzrechte_Normen_Und_0096772677_odukt_Umgesetzt_Werden_Angabe.path,
				},

				{ ...P.Schutzrechte_Normen_Und_0096772677_odukt_Umgesetzt_Werden_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Schutzrechte_Normen_Und_0096772677_odukt_Umgesetzt_Werden_Angabe.path)) ?
					[P.Schutzrechte_Normen_Und_0096891436_odukt_Umgesetzt_Werden_Anzahl]
				:	[]),
			],
		},

		{
			fields: [
				{
					type: 'label',
					path: P.Schutzrechte_Normen_Und_0075605189_ards_Geschaffen_Werden_Angabe.path,
				},

				{ ...P.Schutzrechte_Normen_Und_0075605189_ards_Geschaffen_Werden_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Schutzrechte_Normen_Und_0075605189_ards_Geschaffen_Werden_Angabe.path)) ?
					[P.Schutzrechte_Normen_Und_0075592876_ards_Geschaffen_Werden_Anzahl]
				:	[]),
			],
		},

		{
			fields: [
				{
					type: 'label',
					path: P.Schutzrechte_Normen_Und_0075605189_ards_Geschaffen_Werden_Angabe.path,
				},

				{ ...P.Schutzrechte_Normen_Und_0020582837_ft_Fuer_Das_Vorhaben_Nicht_Zu, type: 'radio', validation: [{ validateFunction: NonRequired }] },
			],
		},
	];

	return struc;
};
